export const FORM_ERROR_DELAY_IN_MS = 500;
export const MAX_SECONDARY_RESIDENCE_LIABILITY_ADDRESSES = 5;
export const MIN_SECONDARY_RESIDENCE_LIABILITY_ADDRESS_LENGTH = 3;
export const MAX_SECONDARY_RESIDENCE_LIABILITY_ADDRESS_LENGTH = 128;
